'use strict'

const uniqBy_ = require('lodash/uniqBy')
const { findContainer } = require('./findContainers')
const { createAdapterContext } = require('../adapters/context')
const { DETAILS_REPEATER, DETAILS_DATASET } = require('../componentRoles')
const { getScopeType, SCOPE_TYPES } = require('./scopeTypes')

module.exports.findConnectedComponents = (roles, $w) => {
  const results = []
  roles.forEach(role => {
    const components = $w('@' + role)
    components && components.forEach(component =>
      component && results.push({role, component})
    )
  })
  return results
}

module.exports.createComponentAdapterContexts = ({connectedComponents, adapterApi, getFieldType, ignoreItemsInRepeater, $w, dependencies}) => {
  const cacs = []

  connectedComponents.forEach(({component, role}) => {
    if (ignoreItemsInRepeater) {
      const isComponentInsidePrimaryOrDetailsRepeater =
        findContainer(component)
          .map(container => getScopeType(container.uniqueId, dependencies, connectedComponents))
          .map(scopeType => scopeType === SCOPE_TYPES.PRIMARY || scopeType === SCOPE_TYPES.DETAILS)
          .getOrElse(false)

      if (isComponentInsidePrimaryOrDetailsRepeater) {
        return
      }
    }

    const adapterContext = createAdapterContext({getFieldType, role, component, $w})

    if (adapterApi().isValidContext(adapterContext)) {
      cacs.push(adapterContext)
    }
  })

  return cacs
}

module.exports.createDetailsRepeatersAdapterContexts = (connectedComponents, getFieldType, dependencies) => {
  const detailsRepeaters = []

  connectedComponents.forEach(({component}) => {
    findContainer(component).chain(container => {
      const scopeType = getScopeType(container.uniqueId, dependencies, connectedComponents)
      if (scopeType === SCOPE_TYPES.DETAILS) {
        detailsRepeaters.push(container)
      }
    })
  })

  const uniqDetailsRepeaters = uniqBy_(detailsRepeaters, 'id')
  return uniqDetailsRepeaters
    .map(detailsRepeater => createAdapterContext({getFieldType, role: DETAILS_REPEATER, component: detailsRepeater}))
}


module.exports.resolveHandshakes = (datasetApi, components) =>
  components
    .filter(({role}) => role === DETAILS_DATASET)
    .map(({component, role}) => ({
      controller: component,
      handshakeInfo: {
        controllerApi: datasetApi,
        connectionConfig: component.connectionConfig,
        role: DETAILS_DATASET
      }
    }))



// WEBPACK FOOTER //
// ./dataset-controller/processConnectedRoles.js